var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLandscape = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.78 11.63L14 6L23 18H1L6.53 10.63L10.54 16H19L14 9.33L11.03 13.3L9.78 11.63ZM6.52 13.9688L5 15.9987H8.04L6.52 13.9688Z",
  fill: "#696F88"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLandscape);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/landscape.437cd404fe603a4f576ad3ba245f008d.svg";